import { CSSProperties } from "@material-ui/core/styles/withStyles";
// import { CHROME_MAX_WIDTH } from '@components/chrome-app-wrapper';
// FIXME
const CHROME_MAX_WIDTH = 300;

export const style: CSSProperties = {
  width: CHROME_MAX_WIDTH,
  right: 0,
  left: "auto",
};

const backdrop: CSSProperties = {
  background: `rgba(255, 255, 255, 0.85)`,
  right: 0,
  left: "auto",
};

const paper: CSSProperties = {
  margin: 0,
  "@media (max-width: 768px)": {
    margin: 0,
    maxWidth: "100%",
    width: "100%",
    maxHeight: "100%",
    height: "100%",
    borderRadius: 0,
  },
};

export const styles = {
  backdrop,
  paper,
};
